/**
 * ClientPortalContext — provides AP applicability gate and role info to all client portal pages.
 *
 * apEnabled:
 *   null  — branding fetch not yet complete (loading)
 *   true  — at least one accessible client has AP enabled; show AP features
 *   false — no accessible client has AP enabled; hide all AP features
 *
 * apOverallRole:
 *   'L1'   — user has group (portfolio-wide) grants → Analytics landing, "Action Plans" nav
 *   'L2'   — user has sub-region grants → Analytics landing, "Action Plans" nav
 *   'L3'   — user has direct site grants → task list landing, "My Actions" nav
 *   'NONE' — no AP grants
 *   null   — not yet resolved
 *
 * Provided by ClientPortalLayout once the portal-branding call resolves.
 * Children must not redirect until apEnabled !== null.
 */
import React, { createContext, useContext } from 'react';

export const ClientPortalContext = createContext({ apEnabled: null, apOverallRole: null });

export const useClientPortal = () => useContext(ClientPortalContext);
